import { has } from 'lodash';
import {
  INIT_VIDEO_STREAM_SUCCESS,
  INIT_SCREEN_STREAM_SUCCESS,
  STOP_VIDEO_STREAM,
  STOP_SCREEN_STREAM,
  SET_DEVICE_CONTROLLER,
  SET_MEETING_SESSION,
  STREAM_ERROR,
  END_MEETING_SESSION,
  INIT_DEVICES_SUCCESS,
  SET_SELECTED_DEVICE,
  OPEN_MEDIA_RECOVERY_MODAL,
  CLOSE_MEDIA_RECOVERY_MODAL,
  SET_SCREEN_SHARE_INITIATED,
  CLEAR_SCREEN_SHARE_INITIATED,
  SET_MEDIA_SHARE_COMPLETED,
} from '../actions/AssesmentRecordingActions';
import {
  CREATE_MEETING_REQUEST,
  CREATE_MEETING_SUCCESS,
  CREATE_MEETING_FAILURE,
  GET_MEETING_REQUEST,
  GET_MEETING_SUCCESS,
  GET_MEETING_FAILURE,
  GET_ATTENDEE_REQUEST,
  GET_ATTENDEE_SUCCESS,
  GET_ATTENDEE_FAILURE,
  UPDATE_MEETING_STATUS_REQUEST,
  UPDATE_MEETING_STATUS_SUCCESS,
  UPDATE_MEETING_STATUS_FAILURE,
  START_RECORDING_REQUEST,
  START_RECORDING_SUCCESS,
  START_RECORDING_FAILURE,
  GET_RECORDING_URLS_REQUEST,
  GET_RECORDING_URLS_SUCCESS,
  GET_RECORDING_URLS_FAILURE,
  CLEAR_MEETING_DATA,
} from '../actions/ProjectMeetingService';

const initialState = {
  videoStream: null,
  screenStream: null,
  deviceController: null,
  meetingSession: null,
  error: null,
  hasVideo: false,
  hasAudio: false,
  hasScreen: false,
  videoInputs: [],
  audioInputs: [],
  audioOutputs: [],
  selectedVideoInput: null,
  selectedAudioInput: null,
  selectedAudioOutput: null,

  recoveryModalOpen: false,
  recoveryReason: 'unknown',
  screenShareInitiated: null,
  mediaShareCompleted: false,

  // Meeting data
  meeting: null,
  attendee: null,
  recording: null,
  recordingUrls: [],

  // Loading states
  isCreatingMeeting: false,
  isGettingMeeting: false,
  isGettingAttendee: false,
  isUpdatingStatus: false,
  isStartingRecording: false,
  isGettingRecordingUrls: false,

  // Error states
  createMeetingError: null,
  getMeetingError: null,
  getAttendeeError: null,
  updateStatusError: null,
  startRecordingError: null,
  getRecordingUrlsError: null,
};

export default function streamReducer(state = initialState, action) {
  switch (action.type) {
    case INIT_DEVICES_SUCCESS: {
      const { videoInputs, audioInputs, audioOutputs } = action.payload;
      return {
        ...state,
        videoInputs,
        audioInputs,
        audioOutputs,
        selectedVideoInput: videoInputs[0]?.deviceId || null,
        selectedAudioInput: audioInputs[0]?.deviceId || null,
        selectedAudioOutput: audioOutputs[0]?.deviceId || null,
      };
    }

    case SET_SELECTED_DEVICE: {
      const { kind, deviceId } = action.payload;
      if (kind === 'video') {
        return { ...state, selectedVideoInput: deviceId };
      } else if (kind === 'audio') {
        return { ...state, selectedAudioInput: deviceId };
      } else if (kind === 'speaker') {
        return { ...state, selectedAudioOutput: deviceId };
      }
      return state;
    }

    case INIT_VIDEO_STREAM_SUCCESS:
      return {
        ...state,
        videoStream: action.payload,
        hasVideo: true,
        hasAudio: true,
        error: null,
      };
    case INIT_SCREEN_STREAM_SUCCESS:
      return {
        ...state,
        screenStream: action.payload,
        hasScreen: true,
        error: null,
      };
    case STOP_VIDEO_STREAM:
      return {
        ...state,
        videoStream: null,
        hasVideo: false,
      };
    case STOP_SCREEN_STREAM:
      return {
        ...state,
        screenStream: null,
        hasScreen: false,
      };
    case SET_DEVICE_CONTROLLER:
      return {
        ...state,
        deviceController: action.payload,
      };
    case SET_MEETING_SESSION:
      return {
        ...state,
        meetingSession: action.payload,
      };
    case STREAM_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case END_MEETING_SESSION:
      return {
        ...initialState,
      };
    case OPEN_MEDIA_RECOVERY_MODAL:
      return { ...state, recoveryModalOpen: true, recoveryReason: action.payload || 'unknown' };
    case CLOSE_MEDIA_RECOVERY_MODAL:
      return { ...state, recoveryModalOpen: false };
    case SET_SCREEN_SHARE_INITIATED:
      return { ...state, screenShareInitiated: action.payload };
    case CLEAR_SCREEN_SHARE_INITIATED:
      return { ...state, screenShareInitiated: null };
    case SET_MEDIA_SHARE_COMPLETED:
      return { ...state, mediaShareCompleted: true };

    // Create Meeting
    case CREATE_MEETING_REQUEST:
      return {
        ...state,
        isCreatingMeeting: true,
        createMeetingError: null,
      };

    case CREATE_MEETING_SUCCESS:
      return {
        ...state,
        isCreatingMeeting: false,
        meeting: action.payload,
        createMeetingError: null,
      };

    case CREATE_MEETING_FAILURE:
      return {
        ...state,
        isCreatingMeeting: false,
        createMeetingError: action.payload,
      };

    // Get Meeting
    case GET_MEETING_REQUEST:
      return {
        ...state,
        isGettingMeeting: true,
        getMeetingError: null,
      };

    case GET_MEETING_SUCCESS:
      return {
        ...state,
        isGettingMeeting: false,
        meeting: action.payload,
        getMeetingError: null,
      };

    case GET_MEETING_FAILURE:
      return {
        ...state,
        isGettingMeeting: false,
        getMeetingError: action.payload,
      };

    // Get Attendee
    case GET_ATTENDEE_REQUEST:
      return {
        ...state,
        isGettingAttendee: true,
        getAttendeeError: null,
      };

    case GET_ATTENDEE_SUCCESS:
      return {
        ...state,
        isGettingAttendee: false,
        attendee: action.payload,
        getAttendeeError: null,
      };

    case GET_ATTENDEE_FAILURE:
      return {
        ...state,
        isGettingAttendee: false,
        getAttendeeError: action.payload,
      };

    // Update Meeting Status
    case UPDATE_MEETING_STATUS_REQUEST:
      return {
        ...state,
        isUpdatingStatus: true,
        updateStatusError: null,
      };

    case UPDATE_MEETING_STATUS_SUCCESS:
      return {
        ...state,
        isUpdatingStatus: false,
        meeting: action.payload,
        updateStatusError: null,
      };

    case UPDATE_MEETING_STATUS_FAILURE:
      return {
        ...state,
        isUpdatingStatus: false,
        updateStatusError: action.payload,
      };

    // Start Recording
    case START_RECORDING_REQUEST:
      return {
        ...state,
        isStartingRecording: true,
        startRecordingError: null,
      };

    case START_RECORDING_SUCCESS:
      return {
        ...state,
        isStartingRecording: false,
        recording: action.payload,
        startRecordingError: null,
      };

    case START_RECORDING_FAILURE:
      return {
        ...state,
        isStartingRecording: false,
        startRecordingError: action.payload,
      };

    // Get Recording URLs
    case GET_RECORDING_URLS_REQUEST:
      return {
        ...state,
        isGettingRecordingUrls: true,
        getRecordingUrlsError: null,
      };

    case GET_RECORDING_URLS_SUCCESS:
      return {
        ...state,
        isGettingRecordingUrls: false,
        recordingUrls: action.payload,
        getRecordingUrlsError: null,
      };

    case GET_RECORDING_URLS_FAILURE:
      return {
        ...state,
        isGettingRecordingUrls: false,
        getRecordingUrlsError: action.payload,
      };

    // Clear Meeting Data
    case CLEAR_MEETING_DATA:
      return {
        ...state,
        meeting: null,
        attendee: null,
        recording: null,
        recordingUrls: [],
        isCreatingMeeting: false,
        isGettingMeeting: false,
        isGettingAttendee: false,
        isUpdatingStatus: false,
        isStartingRecording: false,
        isGettingRecordingUrls: false,
        createMeetingError: null,
        getMeetingError: null,
        getAttendeeError: null,
        updateStatusError: null,
        startRecordingError: null,
        getRecordingUrlsError: null,
      };

    default:
      return state;
  }
}
